"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var __1 = require("../../");
var context_1 = require("../../../context");
var SectionHeading_1 = __importDefault(require("../../SectionHeading"));
var CommentsProfile = function (_a) {
    var client = _a.client;
    var trans = context_1.useSemantics().trans;
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(SectionHeading_1.default, { className: "pb-8", heading: trans('optiiva::headings.comments') }),
        client.notes &&
            client.notes.map(function (_a, index) {
                var date = _a.date, comment = _a.comment;
                return (react_1.default.createElement(__1.DataRow, { unsafe: true, label: date, value: comment || trans('optiiva::misc.empty-line'), dropBorder: client.notes && index === client.notes.length - 1 }));
            })));
};
exports.default = CommentsProfile;
//# sourceMappingURL=CommentsProfile.js.map